<template lang="pug">
    v-tooltip(top max-width="320" :disabled="!tooltipText")
        template(v-slot:activator="{ on, attrs }")
            v-chip(
                v-bind="attrs"
                v-on="on"
                small
                class="ma-1"
                :color="chipColor"
                :text-color="chipTextColor"
                :outlined="!selected"
                @click="$emit('click')"
            ) {{ disposition.disposition_description }}
        span {{ tooltipText }}
</template>

<script lang="ts">
    import Vue from 'vue';
    import {
        dispositionContrastTextColor,
        dispositionDisplayColor,
        dispositionTooltipText,
    } from '@/helpers/dispositions';

    export default Vue.extend({
        props: {
            disposition: {
                type: Object,
                required: true,
            },
            selected: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            chipColor() {
                const color = dispositionDisplayColor(this.disposition);
                if (color) {
                    return color;
                }
                return this.selected ? 'primary' : 'grey lighten-2';
            },
            chipTextColor() {
                const color = dispositionDisplayColor(this.disposition);
                if (!this.selected) {
                    if (!color) {
                        return 'grey darken-3';
                    }
                    return dispositionContrastTextColor(color) === 'white' ? color : 'grey darken-3';
                }
                if (!color) {
                    return 'white';
                }
                return dispositionContrastTextColor(color);
            },
            tooltipText() {
                return dispositionTooltipText(this.disposition);
            },
        },
    });
</script>
